import React, { useEffect } from 'react';
import { WithStyles, ClassNameMap } from '@mui/styles';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Fade } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

import { Logo } from '../../../components/Logos';

import styles from './styles';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>,
}

const Splash = ({ classes, history }: Props): React.ReactElement => {
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setTimeout(() => {
        history.replace('/sign-in');
      }, 5000);
    }
    return () => { mounted = false; };
  }, [history]);

  return (
    <div className={classes.root}>
      <Fade in timeout={2700}>
        <div className={classes.icon}>
          <Logo />
        </div>
      </Fade>
    </div>
  );
};

export default withRouter(withStyles(styles)(Splash));
